import { SubjectListItem } from '@/project-subject/subject-config/subject-config'

export const AgentGeneral: SubjectListItem = {
  id: 'agent_general',
  debug_subject_name: '代理商通用版',
  domains: ['agent.mingting.cn'],
  logo_login_page: require('./_images/logo-login-page.png'),
  logo_dashboard_header: require('./_images/logo-dashboard-header.png'),
  logo_dashboard_header_dark: require('./_images/logo-dashboard-header-dark.png'),
  phone_pre_sale: '',
  phone_after_sale: '',
  mail: '',
  sign_app_id: 'agent',
  sign_key: 'SOyy1KTQ0op56.a'
}
